export default "__VITE_ASSET__D7grO3Ph__"